import React from "react";
import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";
import Switch from "@ui/Switch";
import t from "../../../i18n";
import { HIDE_ON_WIDGET_EXPORT } from "@ui/ExportWidgetButton";

export const useGroupUnitState = createGlobalState({
  storage: "session",
  key: "axisGroupedByUnit",
  type: io.boolean,
  defaultValue: true,
  scoped: true,
});

interface P {
  projectId: string;
}

function GroupUnitInput({ projectId }: P) {
  const [axisGroupedByUnit, setAxisGroupedByUnit] = useGroupUnitState({ scope: projectId });

  const handleChange = React.useCallback(() => {
    setAxisGroupedByUnit(s => !s);
  }, [setAxisGroupedByUnit]);

  return (
    <Switch checked={axisGroupedByUnit} onChange={handleChange} className={HIDE_ON_WIDGET_EXPORT}>
      {t("measures_symptoms.axis_grouped_by_unit")}
    </Switch>
  );
}

export default React.memo(GroupUnitInput);
